import CrudService from "@/services/shared/http/CrudService"

export default class BookingService extends CrudService {
    constructor(params= {}) {
        super('bookings', params)
    }
}
